import api from '..'

export interface TransactionSearchParams {
  search?: string
  otm?: string
  status?: string
  from?: string
  to?: string
  organizationId?: string
}

export class TransactionService {
  static async searchAll(params: TransactionSearchParams) {
    const response = await api.get('/transactions/searching/all-transactions', {
      params: {
        search: params.search || '',
        otm: params.otm || '',
        status: params.status || '',
        from: params.from || '',
        to: params.to || '',
        organizationId: params.organizationId || ''
      }
    })
    return response.data
  }
}
